import { useTranslation } from 'next-i18next'
import React from 'react'
import { URL_TEMPLATE } from '../../libs/constant'

const style = {
  wrapper: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center'
  },
  image: {
    width: '30%'
  },
  reloadButton: {
    cursor: 'pointer'
  }
}

const Fallback = ({ image, altImage, text, isPageLevel, hasBigSizeMessage }) => {
  const { t } = useTranslation()

  return (
    <div style={style.wrapper} className='p-2'>
      <img src={image} style={style.image} alt={altImage} />
      {isPageLevel || hasBigSizeMessage ? <h3 className='text-center'>{text}</h3> : <p className='text-center'>{text}</p>}

      {isPageLevel && (
        <a style={style.reloadButton} href={URL_TEMPLATE.SYSTEM_DASHBOARD} target='_self'>
          {t('page.fallback.reload.text')}
        </a>
      )}
    </div>
  )
}

export default Fallback
